// extracted by mini-css-extract-plugin
export default {"avatar":"LetterAvatar_avatar__aFCFP"};